var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEcuador(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H19V14.25H0V0Z",
    fill: "#FFE800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.125H19V14.25H0V7.125Z",
    fill: "#00148E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.6875H19V14.25H0V10.6875Z",
    fill: "#DA0010"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00374 8.63344L5.84843 10.9045L5.81281 10.857L7.96218 8.58594L7.9978 8.63344H8.00374ZM9.49999 9.00453L6.68562 11.9733L6.63812 11.9258L9.44952 8.95703L9.49999 9.00453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69427 11.9385L6.43124 12.2015L6.13143 12.4278L6.35768 12.1279L6.62071 11.8649L6.69427 11.9385Z",
    fill: "#808080",
    stroke: "black",
    strokeWidth: 0.115216
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96991 10.7773L5.70688 11.0404L5.40706 11.2666L5.63331 10.9668L5.89634 10.7038L5.96991 10.7773Z",
    fill: "#808080",
    stroke: "black",
    strokeWidth: 0.115216
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17325 3.4082C6.17325 3.4082 5.93678 9.80361 6.88263 9.80361C7.82847 9.80361 8.30273 9.13101 8.30273 9.13101L8.29204 5.616L6.17325 3.4082Z",
    fill: "#FFDF00",
    stroke: "black",
    strokeWidth: 0.127456
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75169 4.00488C6.75169 4.34118 6.64615 9.13108 7.11907 9.13108C7.59199 9.13108 8.30271 8.79478 8.30271 8.79478L8.29202 5.61608L6.75169 4.00488Z",
    fill: "#0000C4",
    stroke: "black",
    strokeWidth: 0.127456
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05896 4.32715C7.05896 4.66345 7.11908 8.45774 7.59334 8.45774H8.30272L8.29203 5.61535L7.05896 4.32715Z",
    fill: "#E10000",
    stroke: "black",
    strokeWidth: 0.127456
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12158 3.44398L8.27095 5.71508L8.30955 5.66758L6.16018 3.39648L6.12158 3.44398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47131 4.71875C5.47131 4.71875 4.86176 10.9143 6.69039 10.9143C8.21425 10.9143 8.21425 9.93692 8.51903 9.93692L8.21425 7.65455L5.46958 4.71875H5.47131Z",
    fill: "#FFDF00",
    stroke: "black",
    strokeWidth: 0.142421
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98194 5.74825C6.995 5.74727 7.45753 4.74633 8.61357 4.11277",
    stroke: "black",
    strokeWidth: 0.205711
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79269 4.80452C6.95389 4.87975 7.0559 4.96632 7.14876 5.06726C6.96429 5.02861 6.86911 5.01299 6.7079 4.93776C6.5467 4.86253 6.42356 4.74746 6.32571 4.65436C6.4457 4.69088 6.6306 4.72888 6.79269 4.80452Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.069782
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19705 5.41801C7.20892 5.4382 7.19871 5.46664 7.17359 5.4806C7.14848 5.49455 7.11838 5.48917 7.10621 5.46848C7.09403 5.44779 7.10484 5.42036 7.12995 5.40641C7.15507 5.39245 7.18517 5.39783 7.19705 5.41801Z",
    fill: "#FF0000",
    stroke: "black",
    strokeWidth: 0.0478622
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70365 4.16404C7.6338 4.34136 7.55673 4.45821 7.46791 4.56723C7.50784 4.36995 7.52479 4.26869 7.59464 4.09137C7.6645 3.91404 7.76644 3.77172 7.84886 3.65843C7.81329 3.78811 7.77389 3.98574 7.70365 4.16404Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0657878
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46785 4.15523C7.45173 4.33255 7.4164 4.46989 7.36997 4.60918C7.35782 4.43684 7.34877 4.35072 7.36489 4.1734C7.38101 3.99607 7.43047 3.82347 7.47085 3.68525C7.47141 3.80468 7.48406 3.97692 7.46785 4.15523Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0568026
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62185 4.35756C7.53051 4.46502 7.45368 4.51163 7.37293 4.54192C7.4543 4.39288 7.49417 4.31362 7.58552 4.20615C7.67687 4.09868 7.77477 4.04821 7.85339 4.00902C7.7949 4.09972 7.71371 4.24949 7.62185 4.35756Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0616977
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84357 4.50809C6.95104 4.63705 7.00448 4.76127 7.04485 4.89854C6.90413 4.80283 6.82991 4.75818 6.72244 4.62922C6.61498 4.50025 6.55441 4.33875 6.50691 4.2086C6.59419 4.2833 6.73551 4.37841 6.84357 4.50809Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.070599
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.62725 5.50162C6.76159 5.60909 6.83248 5.71989 6.889 5.84505C6.71809 5.77415 6.62835 5.74233 6.49401 5.63486C6.35968 5.52739 6.27792 5.38204 6.21356 5.26472C6.32061 5.32332 6.49217 5.39356 6.62725 5.50162Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0749572
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25637 5.44313C7.1489 5.61508 7.03264 5.73063 6.8994 5.83964C6.96365 5.65107 6.99144 5.55452 7.0989 5.38257C7.20637 5.21062 7.3598 5.06931 7.48377 4.95673C7.4279 5.08136 7.36443 5.27023 7.25637 5.44313Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0770028
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36861 5.43627C7.19666 5.55448 7.04698 5.61599 6.8875 5.66444C7.03451 5.51298 7.10582 5.43336 7.27777 5.31514C7.44972 5.19693 7.6415 5.12627 7.79564 5.0707C7.68808 5.16534 7.54151 5.3174 7.36861 5.43627Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0740004
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52786 4.20009C8.45264 4.28607 8.38519 4.33701 8.31251 4.38142C8.37444 4.27882 8.40419 4.2255 8.47941 4.13953C8.55464 4.05355 8.64145 3.99299 8.71127 3.94502C8.6652 4.01074 8.60351 4.11364 8.52786 4.20009Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0391885
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.36488 3.94695C8.3219 4.0383 8.27594 4.10694 8.22346 4.17558C8.24982 4.08423 8.26134 4.0383 8.30432 3.94695C8.34731 3.85561 8.40787 3.76981 8.45679 3.70117C8.43417 3.76375 8.40811 3.8551 8.36488 3.94695Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0325542
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61656 4.11061C8.54133 4.15359 8.48481 4.16678 8.42828 4.17081C8.50351 4.10455 8.54133 4.06881 8.61656 4.02582C8.69179 3.98283 8.76244 3.97072 8.81897 3.96169C8.76743 4.0007 8.6922 4.06738 8.61656 4.11061Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0356838
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57841 4.59188C7.44407 4.67248 7.33358 4.71939 7.21851 4.75977C7.34121 4.66254 7.40168 4.61192 7.53602 4.53132C7.67035 4.45072 7.81065 4.3952 7.92323 4.35127C7.83598 4.41331 7.71349 4.51084 7.57841 4.59188Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0448038
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97052 4.71243C7.7932 4.8199 7.64221 4.87061 7.48273 4.90694C7.63844 4.7629 7.71447 4.68666 7.89179 4.57919C8.06911 4.47173 8.2619 4.4152 8.41675 4.37103C8.30415 4.45967 8.14882 4.60437 7.97052 4.71243Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0745788
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76543 6.45211C6.77686 6.44558 6.66879 5.50271 7.39011 4.52195",
    stroke: "black",
    strokeWidth: 0.202486
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87094 4.46489C7.88281 4.48508 7.8726 4.51352 7.84749 4.52747C7.82237 4.54142 7.79227 4.53605 7.78009 4.51536C7.76792 4.49467 7.77873 4.46723 7.80385 4.45328C7.82896 4.43933 7.85906 4.4447 7.87094 4.46489Z",
    fill: "#FF0000",
    stroke: "black",
    strokeWidth: 0.0478622
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19156 4.27739C8.20343 4.29758 8.19322 4.32602 8.1681 4.33997C8.14299 4.35392 8.11288 4.34855 8.10071 4.32786C8.08854 4.30717 8.09935 4.27973 8.12446 4.26578C8.14958 4.25183 8.17968 4.2572 8.19156 4.27739Z",
    fill: "#FF0000",
    stroke: "black",
    strokeWidth: 0.0478622
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2969 4.90642C7.30521 4.92185 7.28971 4.94626 7.26181 4.96021C7.2339 4.97416 7.20448 4.97271 7.19596 4.95688C7.18744 4.94106 7.20335 4.91743 7.23126 4.90348C7.25916 4.88952 7.28858 4.89098 7.2969 4.90642Z",
    fill: "#FF0000",
    stroke: "black",
    strokeWidth: 0.0431539
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39186 4.86442C7.40018 4.87986 7.38468 4.90426 7.35677 4.91822C7.32887 4.93217 7.29945 4.93072 7.29093 4.91489C7.28241 4.89907 7.29832 4.87544 7.32623 4.86148C7.35413 4.84753 7.38355 4.84899 7.39186 4.86442Z",
    fill: "#FF0000",
    stroke: "black",
    strokeWidth: 0.0431539
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33547 4.95427C7.34378 4.9697 7.32829 4.99411 7.30038 5.00806C7.27247 5.02201 7.24305 5.02056 7.23453 5.00474C7.22601 4.98891 7.24192 4.96528 7.26983 4.95133C7.29774 4.93737 7.32716 4.93883 7.33547 4.95427Z",
    fill: "#FF0000",
    stroke: "black",
    strokeWidth: 0.0431539
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50204 4.96641C7.51391 4.99016 7.50204 5.01985 7.47235 5.03469C7.44266 5.04953 7.41297 5.04063 7.4011 5.01391C7.38922 4.98719 7.4011 4.96047 7.43078 4.94563C7.46047 4.93078 7.49016 4.93969 7.49907 4.96641H7.50204Z",
    fill: "#FF0000",
    stroke: "black",
    strokeWidth: 0.07125
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57036 4.89549C7.57927 4.91924 7.57036 4.94893 7.54067 4.96377C7.51099 4.97862 7.4813 4.96971 7.46646 4.94596C7.45161 4.92221 7.46646 4.88955 7.49614 4.87471C7.52583 4.85987 7.55552 4.87174 7.56739 4.89549H7.57036Z",
    fill: "#FF0000",
    stroke: "black",
    strokeWidth: 0.07125
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58516 4.92839C7.59704 4.95214 7.58516 4.9848 7.55548 4.99667C7.52579 5.00855 7.4961 5.00261 7.48423 4.97886C7.47235 4.95511 7.48423 4.92542 7.51391 4.91058C7.5436 4.89573 7.57329 4.90464 7.58516 4.92839Z",
    fill: "#FF0000",
    stroke: "black",
    strokeWidth: 0.07125
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08082 5.37207C6.08082 5.69786 5.47128 9.28524 6.99686 10.2626C7.60641 10.5884 8.52072 9.93682 8.52072 10.2626L8.21595 7.65445L6.08082 5.37207Z",
    fill: "#0000C4",
    stroke: "black",
    strokeWidth: 0.142421
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69038 6.02344C6.69038 6.34923 6.38561 8.95739 7.30164 9.61082C7.91119 10.2624 9.43677 10.0857 9.43677 10.0857L8.21596 7.65423L6.69038 6.02344Z",
    fill: "#E10000",
    stroke: "black",
    strokeWidth: 0.142421
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45654 4.69102L8.27092 7.65977L8.32139 7.61227L5.50701 4.64648L5.45951 4.69398L5.45654 4.69102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02353 4.33837L5.20218 4.3699L5.25473 4.42245C5.24755 4.42191 5.30728 4.47499 5.23371 4.54856C5.16015 4.62212 5.05547 4.51661 5.05547 4.51661C5.05547 4.51661 5.087 4.69527 5.19239 4.80066C5.29778 4.90605 5.42359 4.88474 5.42359 4.88474C5.42359 4.88474 5.30383 4.78659 5.39207 4.70608C5.48042 4.62485 5.51818 4.68506 5.51818 4.68506L5.62327 4.79015L5.69725 4.71617L5.27658 4.2955L5.24505 4.11684L4.97407 4.07195L5.02364 4.33766L5.02353 4.33837Z",
    fill: "#CECECC",
    stroke: "black",
    strokeWidth: 0.0397414
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43811 3.0911L5.65429 3.42621L5.92795 3.50008L5.74929 3.61568L6.07509 3.60517L6.22263 3.71056L6.27548 3.62601L6.12751 3.52032L6.01221 3.19406L5.98038 3.41523L5.81211 3.17274L5.43799 3.09033L5.43811 3.0911Z",
    fill: "#CECECC",
    stroke: "black",
    strokeWidth: 0.0427907
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31749 3.29273C6.31749 3.31055 6.29374 3.32569 6.26643 3.32569C6.23912 3.32569 6.21418 3.31055 6.21418 3.29273C6.21418 3.27492 6.23793 3.25889 6.26643 3.25889C6.29493 3.25889 6.31749 3.27403 6.31749 3.29273ZM6.24387 3.36309C6.24387 3.68194 6.49206 5.03569 6.51224 5.06864C6.51343 5.10872 6.45524 5.12564 6.42793 5.07665C6.34956 4.92169 6.18093 3.65166 6.17499 3.35508C6.17143 3.23306 6.21893 3.22326 6.27356 3.22594C6.31749 3.22772 6.37212 3.25889 6.37212 3.2963C6.37212 3.34083 6.30324 3.37378 6.24387 3.36309Z",
    fill: "#E10000",
    stroke: "black",
    strokeWidth: 0.0822724
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41253 3.60868C6.40362 3.62649 6.37349 3.63569 6.34754 3.62887C6.32159 3.62204 6.30547 3.60066 6.31438 3.58285C6.32329 3.56504 6.35386 3.55494 6.38094 3.56207C6.40801 3.56919 6.42188 3.58998 6.41253 3.60868ZM6.3074 3.66063C6.38934 4.30099 6.11446 5.28988 6.11672 5.32877C6.09826 5.36826 6.03407 5.37152 6.03306 5.31482C6.01955 5.27801 6.33599 4.38471 6.24598 3.6354C6.3036 3.51249 6.35363 3.51457 6.40418 3.5309C6.44503 3.54366 6.48134 3.58849 6.46264 3.6259C6.44037 3.67043 6.35847 3.68616 6.3074 3.66063Z",
    fill: "#0000C4",
    stroke: "black",
    strokeWidth: 0.0862211
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54265 4.49785C5.54265 4.52753 5.51296 4.55722 5.47734 4.55722C5.44171 4.55722 5.41203 4.52753 5.41203 4.49785C5.41203 4.46816 5.44171 4.44441 5.47734 4.44441C5.51296 4.44441 5.53968 4.46816 5.53968 4.49785H5.54265ZM5.44765 4.6166C5.44765 5.148 5.75937 7.40425 5.78312 7.46066C5.78312 7.52597 5.71484 7.55566 5.67921 7.47253C5.58125 7.21425 5.37046 5.09753 5.36156 4.60472C5.35859 4.39988 5.41796 4.38503 5.48625 4.388C5.54265 4.39097 5.60796 4.44441 5.60796 4.50675C5.60796 4.578 5.52187 4.63441 5.44765 4.6166Z",
    fill: "#E10000",
    stroke: "black",
    strokeWidth: 0.16625
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.703 4.77227C5.69112 4.80077 5.65253 4.81609 5.61976 4.80585C5.58698 4.79561 5.56715 4.76203 5.57902 4.73353C5.5909 4.70503 5.63009 4.68829 5.66429 4.69897C5.69849 4.70966 5.71547 4.74235 5.703 4.77227ZM5.56774 4.85724C5.65205 5.87246 5.27194 7.44958 5.2736 7.5113C5.2489 7.57445 5.1672 7.58113 5.16767 7.49109C5.15164 7.43293 5.58164 6.00668 5.49044 4.81859C5.56751 4.62202 5.63104 4.62416 5.6948 4.64892C5.74634 4.66825 5.79111 4.73861 5.76617 4.79846C5.73649 4.86971 5.63187 4.8966 5.56774 4.85724Z",
    fill: "#0000C4",
    stroke: "black",
    strokeWidth: 0.121451
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9962 8.63344L13.1486 10.9045L13.1872 10.857L11.0348 8.58594L10.9962 8.63344ZM9.5 9.00453L12.3144 11.9733L12.3619 11.9258L9.55047 8.95703L9.5 9.00453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3057 11.9385L12.5688 12.2015L12.8686 12.4278L12.6423 12.1279L12.3793 11.8649L12.3057 11.9385Z",
    fill: "#808080",
    stroke: "black",
    strokeWidth: 0.115216
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0301 10.7773L13.2931 11.0404L13.5929 11.2666L13.3667 10.9668L13.1037 10.7038L13.0301 10.7773Z",
    fill: "#808080",
    stroke: "black",
    strokeWidth: 0.115216
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8268 3.40723C12.8268 3.40723 13.0632 9.80263 12.1174 9.80263C11.1715 9.80263 10.6973 9.13003 10.6973 9.13003L10.708 5.61503L12.8268 3.40723Z",
    fill: "#FFDF00",
    stroke: "black",
    strokeWidth: 0.127456
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2483 4.00391C12.2483 4.34021 12.3539 9.13011 11.8809 9.13011C11.408 9.13011 10.6973 8.79381 10.6973 8.79381L10.708 5.61511L12.2483 4.00391Z",
    fill: "#0000C4",
    stroke: "black",
    strokeWidth: 0.127456
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.941 4.32715C11.941 4.66345 11.8809 8.45774 11.4067 8.45774H10.6973L10.708 5.61535L11.941 4.32715Z",
    fill: "#E10000",
    stroke: "black",
    strokeWidth: 0.127456
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8785 3.44301L10.7291 5.7141L10.6905 5.6666L12.8399 3.39551L12.8785 3.44301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1818 5.19716C11.1818 5.19716 11.7843 5.97023 12.075 6.56769C12.3655 7.16639 12.7047 8.07869 12.7047 8.07869C12.7047 8.07869 12.5109 7.18052 12.1451 6.46046C11.6658 5.5546 11.1816 5.2487 11.1818 5.19716Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0594705
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.161 4.58294C11.161 4.58294 11.8334 5.53902 12.1403 6.24811C12.4468 6.95853 12.7881 8.02342 12.7881 8.02342C12.7881 8.02342 12.6225 6.9989 12.2338 6.14168C11.7217 5.06001 11.1567 4.63979 11.161 4.58294Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0687173
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7412 3.6379C11.7412 3.6379 12.217 5.0537 12.3619 5.92918C12.5061 6.80544 12.5942 8.01134 12.5942 8.01134C12.5942 8.01134 12.6858 6.99924 12.4915 5.92485C12.2227 4.5493 11.7215 3.68178 11.7412 3.6379Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0780526
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3142 3.57329C11.3142 3.57329 11.9729 4.83064 12.2295 5.68508C12.4854 6.54073 12.7261 7.7752 12.7261 7.7752C12.7261 7.7752 12.6914 6.65378 12.3599 5.61368C11.9153 4.29238 11.2998 3.63002 11.3142 3.57329Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0790927
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1052 3.9729C12.1052 3.9729 12.4331 5.32665 12.5154 6.1343C12.5971 6.94249 12.6205 8.03291 12.6205 8.03291C12.6205 8.03291 12.7344 7.15042 12.6201 6.15603C12.4576 4.87897 12.0876 4.00805 12.1052 3.9729Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.070141
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2389 4.00977C11.2389 4.00977 11.8762 5.08683 12.1341 5.8397C12.3914 6.59376 12.6447 7.69576 12.6447 7.69576C12.6447 7.69576 12.5832 6.67451 12.2517 5.76014C11.809 4.60114 11.2272 4.0632 11.2389 4.00977Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0721384
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1194 4.76064C11.1194 4.76064 11.7918 5.61448 12.0987 6.26841C12.4053 6.92367 12.7465 7.91862 12.7465 7.91862C12.7465 7.91862 12.5809 6.94386 12.1923 6.15521C11.6801 5.16243 11.1151 4.81619 11.1194 4.76064Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0679579
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2067 4.36812C11.2067 4.36812 11.8252 5.3726 12.0945 6.0992C12.3633 6.82708 12.6495 7.90681 12.6495 7.90681C12.6495 7.90681 12.5349 6.8836 12.192 6.00352C11.7378 4.89092 11.1997 4.42361 11.2067 4.36812Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0678122
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8766 3.6594C11.8766 3.6594 12.2743 5.04554 12.3728 5.89214C12.4706 6.73942 12.4961 7.89765 12.4961 7.89765C12.4961 7.89765 12.6381 6.93725 12.501 5.89715C12.3056 4.56409 11.8549 3.69992 11.8766 3.6594Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0758718
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3307 3.31355C11.3307 3.31355 11.9114 4.61929 12.1216 5.49124C12.3311 6.36435 12.5092 7.61366 12.5092 7.61366C12.5092 7.61366 12.5249 6.49355 12.2506 5.43059C11.8794 4.07836 11.3143 3.36892 11.3307 3.31355Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0780025
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2554 4.07251C12.2554 4.07251 12.5051 5.37241 12.5411 6.14241C12.5764 6.91289 12.5372 7.94821 12.5372 7.94821C12.5372 7.94821 12.7015 7.11678 12.6444 6.16812C12.5553 4.94901 12.2358 4.10499 12.2554 4.07251Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0674425
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2565 3.85159C11.2565 3.85159 11.8372 4.97704 12.0474 5.74744C12.2569 6.51895 12.435 7.6358 12.435 7.6358C12.435 7.6358 12.4507 6.61585 12.1763 5.67862C11.8051 4.48869 11.2401 3.90366 11.2565 3.85159Z",
    fill: "#005B00",
    stroke: "black",
    strokeWidth: 0.0737141
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5287 4.71777C13.5287 4.71777 14.1382 10.9133 12.3096 10.9133C10.7857 10.9133 10.7857 9.93595 10.481 9.93595L10.7857 7.65357L13.5304 4.71777H13.5287Z",
    fill: "#FFDF00",
    stroke: "black",
    strokeWidth: 0.142421
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9192 5.37109C12.9192 5.69688 13.5287 9.28426 12.0031 10.2616C11.3936 10.5874 10.4793 9.93584 10.4793 10.2616L10.784 7.65347L12.9192 5.37109Z",
    fill: "#0000C4",
    stroke: "black",
    strokeWidth: 0.142421
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3096 6.02246C12.3096 6.34825 12.6144 8.95642 11.6984 9.60984C11.0888 10.2614 9.56324 10.0847 9.56324 10.0847L10.784 7.65325L12.3096 6.02246Z",
    fill: "#E10000",
    stroke: "black",
    strokeWidth: 0.142421
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5434 4.69004L10.7291 7.65879L10.6786 7.61129L13.493 4.64551L13.5434 4.69301V4.69004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9765 4.33837L13.7978 4.3699L13.7453 4.42245C13.7525 4.42191 13.6927 4.47499 13.7663 4.54856C13.8399 4.62212 13.9445 4.51661 13.9445 4.51661C13.9445 4.51661 13.913 4.69527 13.8076 4.80066C13.7022 4.90605 13.5764 4.88474 13.5764 4.88474C13.5764 4.88474 13.6962 4.78659 13.6079 4.70608C13.5196 4.62485 13.4818 4.68506 13.4818 4.68506L13.3767 4.79015L13.3027 4.71617L13.7234 4.2955L13.7549 4.11684L14.0259 4.07195L13.9764 4.33766L13.9765 4.33837Z",
    fill: "#CECECC",
    stroke: "black",
    strokeWidth: 0.0397414
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5619 3.09013L13.3457 3.42524L13.072 3.4991L13.2507 3.6147L12.9249 3.60419L12.7774 3.70958L12.7245 3.62503L12.8725 3.51935L12.9878 3.19308L13.0196 3.41425L13.1879 3.17177L13.562 3.08935L13.5619 3.09013Z",
    fill: "#CECECC",
    stroke: "black",
    strokeWidth: 0.0427907
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6855 3.29176C12.6855 3.30957 12.7092 3.32471 12.7366 3.32471C12.7639 3.32471 12.7888 3.30957 12.7888 3.29176C12.7888 3.27394 12.7651 3.25791 12.7366 3.25791C12.7081 3.25791 12.6855 3.27305 12.6855 3.29176ZM12.7591 3.36212C12.7591 3.68096 12.5109 5.03471 12.4907 5.06766C12.4896 5.10774 12.5477 5.12466 12.5751 5.07568C12.6534 4.92071 12.8221 3.65068 12.828 3.3541C12.8316 3.23209 12.7841 3.22229 12.7294 3.22496C12.6855 3.22674 12.6309 3.25791 12.6309 3.29532C12.6309 3.33985 12.6997 3.3728 12.7591 3.36212Z",
    fill: "#E10000",
    stroke: "black",
    strokeWidth: 0.0822724
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5875 3.6077C12.5964 3.62552 12.6265 3.63472 12.6525 3.62789C12.6784 3.62106 12.6945 3.59969 12.6856 3.58187C12.6767 3.56406 12.6461 3.55397 12.6191 3.56109C12.592 3.56822 12.5781 3.589 12.5875 3.6077ZM12.6926 3.65966C12.6107 4.30001 12.8855 5.2889 12.8833 5.3278C12.9017 5.36728 12.9659 5.37055 12.9669 5.31384C12.9804 5.27703 12.664 4.38373 12.754 3.63442C12.6964 3.51152 12.6464 3.51359 12.5958 3.52992C12.555 3.54269 12.5187 3.58752 12.5374 3.62492C12.5596 3.66945 12.6415 3.68519 12.6926 3.65966Z",
    fill: "#0000C4",
    stroke: "black",
    strokeWidth: 0.0862211
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4603 4.49687C13.4603 4.52656 13.49 4.55624 13.5226 4.55624C13.5583 4.55624 13.588 4.52656 13.588 4.49687C13.588 4.46718 13.5583 4.44343 13.5226 4.44343C13.487 4.44343 13.4603 4.46718 13.4603 4.49687ZM13.5494 4.61562C13.4783 5.56787 13.3673 6.51672 13.2169 7.45968C13.2169 7.525 13.2851 7.55468 13.3208 7.47156C13.4187 7.21328 13.6295 5.09656 13.6384 4.60374C13.6414 4.3989 13.582 4.38406 13.5137 4.38702C13.4573 4.38999 13.392 4.44343 13.392 4.50577C13.392 4.57702 13.4781 4.63343 13.5523 4.61562H13.5494Z",
    fill: "#E10000",
    stroke: "black",
    strokeWidth: 0.16625
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.297 4.7713C13.3089 4.7998 13.3475 4.81511 13.3802 4.80487C13.413 4.79463 13.4329 4.76105 13.421 4.73255C13.4091 4.70405 13.3699 4.68731 13.3357 4.698C13.3015 4.70869 13.2845 4.74137 13.297 4.7713ZM13.4323 4.85626C13.3479 5.87149 13.7281 7.44861 13.7264 7.51033C13.7511 7.57347 13.8328 7.58015 13.8323 7.49011C13.8484 7.43195 13.4184 6.0057 13.5096 4.81761C13.4325 4.62105 13.369 4.62319 13.3052 4.64794C13.2537 4.66727 13.2089 4.73763 13.2338 4.79748C13.2635 4.86873 13.3681 4.89563 13.4323 4.85626Z",
    fill: "#0000C4",
    stroke: "black",
    strokeWidth: 0.121451
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52247 12.5447C8.66158 12.6301 8.81921 12.6751 8.97963 12.6751C9.14006 12.6751 9.29769 12.6301 9.43679 12.5447V9.93652H8.82725C9.13202 10.9139 9.13202 11.8931 8.52075 12.5447H8.52247Z",
    fill: "#E10000",
    stroke: "black",
    strokeWidth: 0.142421
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00507 9.99448C9.00507 11.8336 8.56348 12.243 8.56348 12.6129C8.74739 12.6129 8.87 12.4404 9.00507 12.2035C9.18899 11.8336 9.20665 9.96538 9.18899 9.99448H9.00507Z",
    fill: "#0000C4",
    stroke: "black",
    strokeWidth: 0.117557
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63729 9.99456C8.62794 11.0689 8.1718 12.0644 8.25804 12.2847C8.35571 12.4821 8.63729 11.8337 9.00512 12.2015C9.18903 11.8337 9.2067 9.96546 9.18903 9.99248H8.63729V9.99456Z",
    fill: "#0000C4",
    stroke: "black",
    strokeWidth: 0.117557
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67858 9.83713C8.67858 11.0457 8.25568 11.1263 8.25568 11.4486C8.43959 11.4486 8.67754 11.2724 8.67858 11.2888C8.86249 11.0457 8.88015 9.81802 8.86249 9.83713H8.67858Z",
    fill: "#FFDF00",
    stroke: "black",
    strokeWidth: 0.0952964
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31072 9.83713C8.30137 10.5432 7.85561 11.144 7.94185 11.2888C8.04057 11.4172 8.31072 11.0457 8.67855 11.2888C8.86246 11.0457 8.88013 9.81802 8.86246 9.83713H8.31072Z",
    fill: "#FFDF00",
    stroke: "black",
    strokeWidth: 0.0952964
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4775 12.5447C10.3384 12.6301 10.1808 12.6751 10.0204 12.6751C9.85994 12.6751 9.70232 12.6301 9.56321 12.5447V9.93652H10.1728C9.86798 10.9139 9.86798 11.8931 10.4792 12.5447H10.4775Z",
    fill: "#E10000",
    stroke: "black",
    strokeWidth: 0.142421
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99487 9.99448C9.99487 11.8336 10.4365 12.243 10.4365 12.6129C10.2526 12.6129 10.1299 12.4404 9.99487 12.2035C9.81096 11.8336 9.79329 9.96538 9.81096 9.99448H9.99487Z",
    fill: "#0000C4",
    stroke: "black",
    strokeWidth: 0.117557
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3627 9.99456C10.3721 11.0689 10.8282 12.0644 10.742 12.2847C10.6443 12.4821 10.3627 11.8337 9.99488 12.2015C9.81097 11.8337 9.7933 9.96546 9.81097 9.99248H10.3627V9.99456Z",
    fill: "#0000C4",
    stroke: "black",
    strokeWidth: 0.117557
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3214 9.83713C10.3214 11.0457 10.7443 11.1263 10.7443 11.4486C10.5604 11.4486 10.3225 11.2724 10.3214 11.2888C10.1375 11.0457 10.1198 9.81802 10.1375 9.83713H10.3214Z",
    fill: "#FFDF00",
    stroke: "black",
    strokeWidth: 0.0952964
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6893 9.83713C10.6986 10.5432 11.1444 11.144 11.0581 11.2888C10.9594 11.4172 10.6893 11.0457 10.3214 11.2888C10.1375 11.0457 10.1199 9.81802 10.1375 9.83713H10.6893Z",
    fill: "#FFDF00",
    stroke: "black",
    strokeWidth: 0.0952964
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17344 10.1402L6.85388 10.3714L7.17344 10.6026L7.33304 10.487L7.41284 10.6026L7.49264 10.8338L7.57279 10.6026L7.65259 10.487H11.9344V10.2558H7.65224L7.57244 10.1395C7.57244 10.0239 7.58918 9.90833 7.65259 9.90833H7.97179C7.97179 9.79273 7.81219 9.56152 7.49264 9.56152C7.17344 9.56152 7.01348 9.79273 7.01348 9.90833H7.33304C7.39609 9.90833 7.41284 10.0239 7.41284 10.1402L7.33304 10.2558L7.17308 10.1395L7.17344 10.1402Z",
    fill: "#908F8A",
    stroke: "black",
    strokeWidth: 0.173651
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.11072 10.7007H10.9095V10.8426H8.11155L8.11072 10.7007ZM8.11072 10.558H10.9095V10.7007H8.11155L8.11072 10.558ZM8.11072 10.4161H10.9095V10.5588H8.11155L8.11072 10.4161ZM8.11072 10.2743H10.9095V10.4161H8.11155L8.11072 10.2743ZM8.11072 10.1324H10.9095V10.2743H8.11155L8.11072 10.1324ZM8.11072 9.98971H10.9095V10.1324H8.11155L8.11072 9.98971ZM8.11072 9.84863H10.9095V9.98971H8.11155L8.11072 9.84863Z",
    fill: "#B74D00",
    stroke: "black",
    strokeWidth: 0.117543
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2442 9.83984L9.26694 10.8338H9.41315L8.39115 9.84065H8.24494L8.2442 9.83984Z",
    fill: "#908F8A",
    stroke: "black",
    strokeWidth: 0.203624
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2442 10.8643L9.26694 9.87032H9.41315L8.39115 10.8635H8.24494L8.2442 10.8643Z",
    fill: "#908F8A",
    stroke: "black",
    strokeWidth: 0.203624
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27258 9.83984V10.8338H8.41971V9.83984H8.27258Z",
    fill: "#908F8A",
    stroke: "black",
    strokeWidth: 0.202435
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55939 9.83984L10.5821 10.8338H10.7283L9.70634 9.84065H9.56013L9.55939 9.83984Z",
    fill: "#908F8A",
    stroke: "black",
    strokeWidth: 0.203624
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55939 10.8643L10.5821 9.87032H10.7283L9.70634 10.8635H9.56013L9.55939 10.8643Z",
    fill: "#908F8A",
    stroke: "black",
    strokeWidth: 0.203624
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.612 9.83984V10.8338H10.7591V9.83984H10.612Z",
    fill: "#908F8A",
    stroke: "black",
    strokeWidth: 0.202435
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5907 9.83984V10.8338H9.73782V9.83984H9.5907Z",
    fill: "#908F8A",
    stroke: "black",
    strokeWidth: 0.202435
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29382 9.83984V10.8338H9.44095V9.83984H9.29382Z",
    fill: "#908F8A",
    stroke: "black",
    strokeWidth: 0.202435
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5719 7.0022C11.5719 8.62195 10.6145 9.93616 9.43676 9.93616C8.259 9.93616 7.30164 8.62195 7.30164 7.0022C7.30164 5.38245 8.25728 4.06641 9.43676 4.06641C10.6162 4.06641 11.5719 5.38061 11.5719 7.00036V7.0022ZM11.2671 7.0022C11.2671 8.44157 10.4475 9.61037 9.43676 9.61037C8.42602 9.61037 7.60641 8.44157 7.60641 7.0022C7.60641 5.56099 8.42602 4.3922 9.43676 4.3922C10.4475 4.3922 11.2671 5.56099 11.2671 7.0022Z",
    fill: "#FFDF00",
    stroke: "black",
    strokeWidth: 0.142421
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2684 4.29833C10.0119 4.14923 9.7312 4.06641 9.43676 4.06641C9.14233 4.06641 8.86166 4.14923 8.6051 4.29649L8.72563 4.59835C8.94216 4.46493 9.1877 4.3947 9.43763 4.3947C9.68755 4.3947 9.93309 4.46493 10.1496 4.59835L10.2684 4.29649V4.29833Z",
    fill: "#FFDF00",
    stroke: "black",
    strokeWidth: 0.142421
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2744 9.62746C10.0178 9.77655 9.73713 9.85938 9.44269 9.85938C9.14825 9.85938 8.86758 9.77655 8.61102 9.6293L8.73155 9.32744C8.94809 9.46086 9.19362 9.53109 9.44355 9.53109C9.69348 9.53109 9.93901 9.46086 10.1555 9.32744L10.2744 9.6293V9.62746Z",
    fill: "#FFDF00",
    stroke: "black",
    strokeWidth: 0.142421
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2694 7.00312C11.2694 8.44297 10.447 9.60969 9.43764 9.60969C8.42826 9.60969 7.60889 8.44297 7.60889 7.00312C7.60889 5.56328 8.42826 4.39062 9.43764 4.39062C10.447 4.39062 11.2694 5.56031 11.2694 7.00312Z",
    fill: "#A7CFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2671 7.00303C11.2861 7.49264 11.1879 7.73192 11.0622 8.24177C11.0295 8.29699 10.8728 8.12213 10.7798 8.03562C10.6869 7.94911 10.6455 8.11293 10.5284 7.9804C10.4131 7.84419 10.339 8.01721 10.2529 7.90309C10.1669 7.78898 9.36962 7.77425 9.36962 7.76321C9.44883 7.72271 9.85519 7.76689 9.78976 7.5589C9.71572 7.3417 9.25598 7.55154 9.19399 7.27544C9.15095 6.99935 8.27107 6.9883 8.20736 6.92204C8.23319 7.02512 8.89267 7.06929 8.87717 7.33618C8.86167 7.44662 8.22802 7.47791 8.16604 7.56994C8.11438 7.6859 8.66538 7.53865 8.68432 7.68038C8.68432 7.73928 8.60339 7.68038 8.31756 7.77241C8.17292 7.81843 8.58273 7.96199 8.42776 8.04114C8.27279 8.12029 7.94047 8.15526 7.95424 8.18839C8.0059 8.35405 8.72392 8.54915 8.65332 8.57676C8.39849 8.69824 8.26418 8.77739 8.14193 8.84733C7.78371 8.3095 7.59605 7.66316 7.60643 7.00303C8.15226 6.7932 8.03689 6.74902 9.04591 6.74902C10.0549 6.74902 10.389 6.79136 11.2671 7.00303Z",
    fill: "#AFFF7B",
    stroke: "black",
    strokeWidth: 0.142421
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2671 7.00315C11.1293 7.00315 10.9847 7.06573 10.8366 7.06573C10.6868 7.06573 10.5353 7.00131 10.3803 7.00131C10.2254 7.00131 10.048 7.08598 9.88959 7.08598C9.72946 7.08598 9.58998 7.00315 9.42985 7.00315C9.26971 7.00315 9.10958 7.06573 8.95117 7.06573C8.79276 7.06573 8.63607 7.00131 8.48282 7.00131C8.32957 7.00131 8.17805 7.06573 8.03169 7.06573C7.88533 7.06573 7.74241 7.00131 7.60638 7.00131C7.60638 6.64239 7.65804 6.30003 7.75102 5.98712C8.21593 6.02394 7.94043 5.69815 8.21593 5.69815C8.29635 5.69349 8.37678 5.70717 8.45189 5.73826C8.52699 5.76936 8.59506 5.81717 8.65156 5.87853C8.69289 5.87853 8.89951 5.6687 9.13197 5.69815C9.3627 5.7276 9.27832 6.20064 9.58654 6.22456C9.74151 6.34973 9.83277 6.42887 10.0463 6.48041C10.3511 6.50986 11.224 6.43439 11.2292 6.47673C11.2543 6.65092 11.267 6.8269 11.2671 7.00315Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.142421
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71318 8.52085C9.71318 8.43962 9.79333 8.38547 9.79333 8.2558C9.79333 8.12612 9.72209 8.12327 9.71971 8.00215C9.71852 7.95227 9.78087 7.9024 9.80818 7.8967C9.83549 7.891 9.85865 8.00215 9.85865 8.02637C9.85865 8.0506 9.83074 7.96652 9.80758 7.9651C9.78443 7.96367 9.73455 7.97365 9.73455 7.99787C9.73455 8.04632 9.82243 8.10617 9.8159 8.26862C9.80937 8.42822 9.74049 8.47667 9.74049 8.52512C9.74049 8.57357 9.77018 8.70752 9.77018 8.70752C9.77018 8.70752 9.71259 8.60065 9.71259 8.51942L9.71318 8.52085Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.0735867
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96968 8.50874C9.96968 8.42751 9.88953 8.37336 9.88953 8.24369C9.88953 8.11401 9.96078 8.11116 9.96315 7.99004C9.96909 7.93304 9.89309 7.89599 9.86578 7.89171C9.83847 7.88744 9.8064 8.00571 9.8064 8.02851C9.8064 8.05131 9.83847 7.95441 9.86162 7.95299C9.88478 7.95156 9.94831 7.96154 9.94831 7.98576C9.94831 8.03421 9.86043 8.09406 9.86696 8.25651C9.8735 8.41611 9.94237 8.46456 9.94237 8.51301C9.94237 8.56146 9.91268 8.69541 9.91268 8.69541C9.91268 8.69541 9.97028 8.58854 9.97028 8.50731L9.96968 8.50874Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.0735867
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.88596 7.86426C9.88596 7.90285 9.86518 7.93551 9.84143 7.93551C9.81768 7.93551 9.79987 7.90285 9.79987 7.86129C9.79987 7.81973 9.81768 7.79004 9.84143 7.79004C9.86518 7.79004 9.88596 7.8227 9.88596 7.86426ZM10.3907 8.13145H10.4025V8.71035H10.3877L10.3907 8.13145ZM10.5124 8.08395H10.5272V8.66879H10.5124V8.08395Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4678 8.34785V8.33301L10.5866 8.35379V8.36863L10.4678 8.34785Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7707 8.51603C8.7707 8.51603 9.21839 8.72587 9.31654 8.85103C9.41296 8.97619 9.37508 8.97619 9.37508 8.97619L10.3686 9.01853C10.3686 8.95594 10.5442 8.95594 10.5838 8.80869C10.6234 8.66328 10.6234 8.62095 10.6234 8.62095L10.3118 8.72586L10.329 8.53812H10.0569L10.0173 8.72586L9.4319 8.70562L9.4715 8.20312L9.35442 8.22337L9.3372 8.70194C9.31654 8.70194 8.78964 8.55653 8.76898 8.51603H8.7707Z",
    fill: "#B74D00",
    stroke: "black",
    strokeWidth: 0.142421
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86987 5.51906C7.86987 5.51906 8.51902 5.31291 9.45572 5.32764C10.3924 5.34236 11.0416 5.56324 11.0278 5.56324C11.014 5.56324 10.8487 5.22456 10.8487 5.22456C10.8487 5.22456 10.1875 5.0313 9.44194 5.01657C8.69809 5.00185 8.04895 5.16382 8.06444 5.17854L7.86987 5.51906Z",
    fill: "#FEDE00",
    stroke: "#FEDE00",
    strokeWidth: 0.142421
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08438 5.04117L9.48813 5.03523L9.49406 5.26977L9.09031 5.27867L9.08438 5.04117ZM8.15812 5.16883L8.01562 5.40336L8.49656 5.34398L8.45797 5.11539L8.15812 5.17477V5.16883ZM8.56484 5.07977L8.96859 5.04711L8.98641 5.27867L8.58563 5.3143L8.56484 5.07977ZM10.0166 5.05898L9.61578 5.0293L9.60094 5.2668L10.0017 5.29055L10.0166 5.05898ZM10.8834 5.20742L11.0289 5.49242L10.5955 5.38555L10.643 5.15695L10.8805 5.20445L10.8834 5.20742ZM10.5331 5.11836L10.1353 5.06789L10.1056 5.29945L10.5064 5.35289L10.5331 5.11836Z",
    fill: "#38A9F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45573 5.65142L9.41269 5.40294L9.28183 5.61461L9.33004 5.36613L9.13547 5.50785L9.26633 5.29986L9.0356 5.3514L9.23361 5.21151L9.00116 5.1655L9.23361 5.11764L9.0356 4.97776L9.26633 5.02929L9.13374 4.8213L9.33004 4.96303L9.28183 4.71455L9.41269 4.92622L9.45573 4.67773L9.5005 4.92622L9.62964 4.71455L9.58315 4.96303L9.77772 4.8213L9.64514 5.02929L9.87759 4.97776L9.67958 5.11764L9.91203 5.1655L9.67958 5.21151L9.87759 5.3514L9.64514 5.29986L9.77772 5.50785L9.58315 5.36613L9.63137 5.61461L9.5005 5.40294L9.45573 5.65142Z",
    fill: "#FFDF00",
    stroke: "black",
    strokeWidth: 0.142421
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79953 5.00965C9.79953 5.1477 9.68785 5.25902 9.54909 5.25902C9.41033 5.25902 9.29865 5.1477 9.29865 5.00965C9.29865 4.8716 9.41033 4.75879 9.54909 4.75879C9.68785 4.75879 9.79953 4.8716 9.79953 5.01113V5.00965Z",
    fill: "#FFDF00",
    stroke: "black",
    strokeWidth: 0.12679
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5208 5.06484C9.5208 5.07969 9.48221 5.09453 9.43768 5.09453C9.39315 5.09453 9.35455 5.07969 9.35455 5.06484C9.35455 5.05 9.39018 5.03516 9.43768 5.03516C9.48518 5.03516 9.5208 5.04703 9.5208 5.06484ZM9.69893 5.06484C9.69893 5.07969 9.67221 5.09453 9.63955 5.09453C9.6069 5.09453 9.57424 5.07969 9.57424 5.06484C9.57424 5.04703 9.60393 5.03516 9.63658 5.03516C9.66924 5.03516 9.69893 5.04703 9.69893 5.06484Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5121 5.16714L9.52943 5.17712C9.48775 5.15165 9.50675 5.16109 9.57218 5.22557C9.60956 5.20384 9.61665 5.18407 9.63987 5.15717",
    stroke: "black",
    strokeWidth: 0.143844
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34636 5.298L9.36014 5.31273C9.32742 5.27592 9.34292 5.29432 9.41524 5.34218C9.48411 5.35138 9.55471 5.32009 9.59604 5.26855",
    stroke: "black",
    strokeWidth: 0.142421
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35406 5.7832C8.35406 5.7832 8.38374 6.0207 8.20265 6.31758C8.02453 6.61148 8.05125 6.50758 8.05125 6.50758C8.05125 6.50758 8.13437 6.67086 8.11953 6.67086C8.10468 6.67086 7.97999 6.52242 7.97999 6.52242L7.83156 6.6857C7.83156 6.6857 7.96812 6.43336 7.95328 6.43336C7.93843 6.43336 7.91171 6.3443 7.91171 6.3443L8.02156 6.29977C8.02156 6.29977 8.18781 5.99102 8.18781 6.00586C8.18781 6.0207 7.69203 6.3443 7.69203 6.3443L8.35406 5.78617V5.7832ZM8.4639 5.87227C8.44906 5.87227 8.53218 6.10977 8.60343 6.22852C8.67171 6.34727 8.67171 6.49273 8.67171 6.49273L8.90624 6.61148L8.60343 6.1543L8.7964 6.22555L8.4639 5.87227ZM8.4639 6.49273C8.4639 6.49273 8.63015 6.67086 8.64203 6.73023C8.6539 6.78961 8.65687 6.92023 8.65687 6.92023L8.58859 6.7718L8.49062 6.90539C8.49062 6.90539 8.56187 6.69758 8.54703 6.68273C8.53218 6.66789 8.43718 6.75695 8.43718 6.75695C8.43718 6.75695 8.47874 6.6382 8.47874 6.62633C8.47874 6.61445 8.47874 6.53727 8.4639 6.49273ZM7.63562 6.90539C7.69203 6.86086 7.80187 6.83117 7.80187 6.83117C7.80187 6.83117 7.73359 6.94992 7.71874 6.94992C7.7039 6.94992 7.66531 6.94992 7.63562 6.90539ZM9.53859 6.2582C9.53859 6.2582 9.89781 6.47789 9.89781 6.49273C9.89781 6.50758 9.66328 6.38883 9.66328 6.38883L9.53859 6.2582ZM8.8914 5.79805C8.92109 5.81289 9.41687 6.22555 9.40203 6.22555C9.38718 6.22555 9.18234 6.1068 9.18234 6.12461V6.22555L9.06953 5.99102L9.04281 6.08008L8.89437 5.79805H8.8914ZM9.01609 6.46305L9.15265 6.74211L9.29218 6.71242C9.29218 6.71242 9.03093 6.46305 9.01609 6.46305ZM9.44359 6.28492L9.45843 6.55211C9.45843 6.55211 9.53859 6.62633 9.53859 6.61148C9.53859 6.59664 9.45843 6.29977 9.44359 6.28492Z",
    fill: "#B7E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.42096 2.65707C5.42096 2.65707 6.0444 2.3127 6.75393 2.05738C7.27595 1.86558 7.8146 1.72247 8.36299 1.62988C8.5708 1.62988 8.93299 2.15832 8.99236 2.15832C9.05174 2.15832 9.29221 2.00988 9.59502 2.00988C9.89783 2.00988 10.073 2.24738 10.1353 2.24738H10.6756C10.735 2.24738 10.4945 1.65957 10.6756 1.68926C10.7647 1.7041 11.5306 1.82285 12.2431 2.05145C12.9556 2.28301 13.965 2.6927 13.965 2.6927C13.965 2.6927 12.3174 2.90941 11.875 2.84707C11.8156 2.87676 11.875 3.23301 11.786 3.07566C11.6494 3.04598 11.1417 2.96582 11.0527 2.96582C10.9636 2.96582 10.7944 3.06676 10.5539 3.12613C10.3164 3.18551 10.0136 3.27457 10.0136 3.27457L10.4055 3.8891L9.92455 4.1266C9.92455 4.1266 9.62471 3.42004 9.50299 3.42004C9.38127 3.42004 9.32486 3.91879 9.17346 3.8891C9.02502 3.85941 8.96564 3.42004 8.84393 3.30129C8.72518 3.18551 8.08986 3.14098 7.84939 3.08457C7.6119 3.0252 7.22299 2.98066 7.01221 2.92129C6.8044 2.86191 6.59065 3.06973 6.50158 3.06973C6.41252 3.06973 6.62033 2.8916 6.53127 2.86191C6.44221 2.83223 6.38283 2.95098 6.32346 2.95098C6.26408 2.95098 5.63174 2.83223 5.57237 2.80254C5.51299 2.77285 5.7208 2.65707 5.66143 2.65707H5.42096Z",
    fill: "#984000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89957 2.36301C9.89957 2.52665 9.76503 2.65941 9.59979 2.65941C9.43455 2.65941 9.30066 2.52665 9.30066 2.36301C9.30066 2.19937 9.43455 2.06738 9.59979 2.06738C9.76503 2.06738 9.89957 2.20015 9.89957 2.36301Z",
    fill: "#808080",
    stroke: "#772600",
    strokeWidth: 0.210166
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.37988 2.41924C8.43359 2.35654 8.50012 2.26154 8.67406 2.26154C8.71413 2.24539 8.71413 2.15039 8.80712 2.15039C8.9009 2.15039 8.87365 2.24539 8.94098 2.27769C9.00751 2.30904 9.55498 2.24539 9.55498 2.24539C9.55498 2.24539 9.60788 2.29289 9.60788 2.35654C9.60788 2.42019 9.5678 2.46674 9.55498 2.46674C9.54215 2.46674 9.00751 2.41924 8.96743 2.43539C8.92735 2.45154 8.9009 2.46674 8.80712 2.46674C8.71413 2.46674 8.68688 2.35654 8.62035 2.35654C8.55382 2.35654 8.48729 2.34039 8.37988 2.42019V2.41924Z",
    fill: "#984000",
    stroke: "#772600",
    strokeWidth: 0.369995
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07404 3.81041C9.06603 3.81041 9.04839 3.75911 9.02114 3.71541C9.0019 3.65841 8.97785 3.69071 8.95381 3.60426C8.95701 3.51496 8.95942 3.49976 8.95381 3.41426C8.8993 3.36866 8.87606 3.35536 8.83357 3.27176C8.76624 3.20526 8.84399 3.09126 8.85682 3.00766C8.7975 2.99246 8.76865 3.11691 8.67807 3.16156C8.61234 3.21381 8.67005 3.05326 8.63799 2.96016C8.61635 2.82811 8.55142 3.02666 8.52738 3.08271C8.48329 3.11786 8.46966 3.16346 8.40714 3.09791C8.40714 3.04946 8.44642 2.91266 8.42959 2.88606C8.36706 2.92311 8.2853 3.03331 8.22038 3.05041C8.15465 3.03426 8.234 2.90981 8.234 2.81766C8.20996 2.80816 8.11618 3.06276 8.0777 3.06466C8.03923 3.06656 8.05606 2.81766 8.03762 2.82336C8.00957 2.87086 7.95266 2.96966 7.91338 3.00386C7.83723 2.99151 7.9246 2.83761 7.93582 2.78061C7.94865 2.71221 7.86448 2.91171 7.8196 2.92406C7.78673 2.95826 7.72181 2.98106 7.69936 2.98771C7.72501 2.92881 7.85166 2.81006 7.84364 2.77586C7.7691 2.77871 7.65608 2.89461 7.59276 2.90886C7.55107 2.90886 7.49336 2.92501 7.48615 2.92406C7.48935 2.84806 7.64165 2.78536 7.6657 2.73881C7.59115 2.75306 7.44767 2.83096 7.40599 2.89271C7.35629 2.90506 7.29377 2.92121 7.24568 2.89271C7.25289 2.82146 7.36511 2.68371 7.38996 2.63811C7.32183 2.67326 7.28816 2.70081 7.21602 2.71696C7.20239 2.73311 7.16392 2.76731 7.17594 2.73311C7.19758 2.66661 7.22965 2.63811 7.2561 2.59061C7.19598 2.60391 7.17354 2.64476 7.10941 2.68561C7.06853 2.68751 6.95151 2.82716 6.91223 2.82906C6.84575 2.89117 6.76815 2.93439 6.68539 2.95541C6.62447 2.96871 6.59481 2.98391 6.56515 3.01906C6.59561 2.95541 6.6421 2.89556 6.68539 2.86136C6.71181 2.80369 6.75431 2.7587 6.80562 2.73406C6.82085 2.71221 6.86253 2.70651 6.81845 2.70271C6.78077 2.74261 6.71665 2.78821 6.68539 2.81386C6.64451 2.84426 6.59721 2.87466 6.57798 2.86136C6.59962 2.79296 6.63809 2.77586 6.67176 2.71886C6.7423 2.66566 6.67176 2.69986 6.61806 2.71886C6.58359 2.75496 6.52187 2.78251 6.47137 2.81386C6.41526 2.83096 6.37759 2.87086 6.31106 2.89271C6.31106 2.91551 6.33029 2.85186 6.33831 2.82906C6.39282 2.75876 6.40724 2.73881 6.47137 2.71886C6.4874 2.69131 6.50664 2.70271 6.45854 2.70271C6.42167 2.74071 6.37198 2.76161 6.32468 2.79771C6.27739 2.81006 6.21567 2.81386 6.15155 2.81386C6.06818 2.82526 6.0754 2.83286 6.15155 2.78156C6.19403 2.73406 6.2293 2.74641 6.2317 2.68656C6.1812 2.73026 6.11948 2.76256 6.05776 2.79771C6.00646 2.79961 5.99284 2.81386 5.93753 2.81386C5.96398 2.78156 5.98001 2.74071 6.01769 2.71886C6.07379 2.64571 5.98242 2.70461 5.96398 2.71886H5.76359C5.72832 2.77206 5.76199 2.71886 5.79084 2.68656C5.82531 2.66566 5.86138 2.63811 5.85737 2.62386C5.81729 2.66471 5.77161 2.68371 5.73714 2.71886C5.70027 2.73216 5.65698 2.73786 5.65698 2.75021C5.68664 2.69986 5.73393 2.66851 5.76439 2.62386C5.80928 2.61246 5.84775 2.59536 5.85737 2.57636H5.67061H5.80367C5.8718 2.57636 5.92951 2.56876 5.99123 2.56021C6.09704 2.53931 5.98162 2.52886 5.9239 2.52886C5.91348 2.50416 5.95757 2.49086 6.00406 2.48136C6.04414 2.45856 6.09464 2.43861 6.13792 2.41771C6.17613 2.40392 6.21215 2.38273 6.24453 2.35501C6.20445 2.35691 6.20445 2.36831 6.16437 2.37021C6.22449 2.36546 6.26697 2.35501 6.33831 2.35501C6.39706 2.33205 6.45484 2.30574 6.51145 2.27616C6.53549 2.24196 6.54511 2.24386 6.485 2.24386C6.5387 2.22391 6.61485 2.21346 6.65813 2.19636C6.71338 2.18264 6.76716 2.16161 6.81845 2.13366C6.85772 2.10231 6.88017 2.06526 6.92505 2.03866C6.97716 2.08046 6.97796 2.08616 7.07174 2.08616C7.14709 2.08521 7.19358 2.06336 7.23205 2.02251C7.28976 2.00351 7.30018 1.97121 7.36591 1.95981C7.42768 1.97131 7.49017 1.97639 7.55268 1.97501C7.6168 1.95506 7.67852 1.91801 7.72581 1.88001C7.76669 1.85626 7.81559 1.82206 7.85968 1.80116C7.90777 1.83061 7.94624 1.85436 8.00636 1.86481C8.06808 1.85341 8.10095 1.81731 8.15305 1.80116C8.18518 1.76062 8.22723 1.73305 8.27328 1.72231C8.35103 1.67671 8.34542 1.73656 8.37989 1.78501C8.41997 1.83441 8.47127 1.81066 8.52657 1.83251C8.55784 1.88951 8.58028 1.92751 8.62036 1.95886C8.65162 2.00446 8.68849 2.01586 8.75422 2.02251C8.77827 2.06051 8.75903 2.08711 8.80712 2.10136C8.82636 2.12606 8.85922 2.13556 8.88728 2.14886M10.0087 2.38636H10.2219C10.2988 2.38731 10.3253 2.41486 10.3958 2.41771H10.5826C10.6507 2.41486 10.6868 2.39586 10.7557 2.38636C10.8719 2.38446 10.8327 2.37401 10.8094 2.29136C10.7886 2.22961 10.7854 2.20016 10.7557 2.16501C10.7445 2.08901 10.7188 2.06241 10.7156 1.97501C10.7036 1.90851 10.6812 1.86386 10.7028 1.78501C10.7333 1.83916 10.7453 1.86101 10.8231 1.86481C10.9032 1.86481 10.9345 1.86196 10.9834 1.89616C11.0202 1.94271 11.0699 1.92751 11.1437 1.92751C11.2046 1.94081 11.215 1.97786 11.2631 2.00636C11.32 2.04436 11.3569 2.05386 11.4362 2.05386C11.5004 2.06811 11.5565 2.07856 11.5966 2.10136C11.631 2.14981 11.6847 2.16216 11.7569 2.16501C11.7969 2.16501 11.829 2.16026 11.8635 2.14886C11.9252 2.15266 11.9877 2.14886 12.0639 2.14886C12.1136 2.21726 12.1248 2.24291 12.2106 2.24386C12.2699 2.29326 12.3196 2.30086 12.3709 2.32271H12.5713C12.6434 2.32936 12.6658 2.36451 12.7316 2.38636C12.788 2.41656 12.8458 2.44289 12.9047 2.46521C12.9621 2.47752 13.0204 2.48293 13.0786 2.48136C13.1275 2.51176 13.1877 2.51366 13.2253 2.54406C13.2806 2.55831 13.356 2.57541 13.3985 2.59156C13.469 2.60296 13.4963 2.62956 13.5588 2.63906C13.6125 2.65806 13.5411 2.67326 13.5051 2.68656C13.4265 2.68371 13.4209 2.64856 13.3448 2.63906C13.3047 2.61151 13.2438 2.61531 13.1845 2.59156H13.1716C13.2245 2.62956 13.2758 2.65331 13.2518 2.71886C13.1837 2.71886 13.1283 2.70841 13.065 2.70271C12.9977 2.68751 12.9672 2.67136 12.8919 2.67136C12.9672 2.64951 12.9865 2.67326 13.0386 2.70271C13.0578 2.77871 13.0161 2.75021 12.9448 2.75021C12.8839 2.72456 12.847 2.69321 12.7716 2.68656H12.6113C12.6907 2.69036 12.7075 2.72551 12.758 2.76636C12.762 2.79106 12.7572 2.78916 12.7179 2.79771C12.6763 2.75496 12.6226 2.74071 12.5576 2.71886C12.4943 2.71601 12.4278 2.70936 12.3709 2.68656C12.3316 2.68371 12.338 2.62861 12.4246 2.71886C12.4767 2.75496 12.4951 2.78536 12.4911 2.81386C12.4222 2.79296 12.3885 2.76066 12.3444 2.73406C12.2845 2.70941 12.221 2.69877 12.1577 2.70271C12.0887 2.68086 12.1649 2.66851 12.2106 2.75021C12.3099 2.83381 12.1977 2.79771 12.1577 2.78156C12.0975 2.76161 12.035 2.73216 11.9837 2.71886C11.9436 2.70461 11.9084 2.69131 11.8635 2.68656C11.9332 2.69416 11.9565 2.72361 11.9837 2.78156C12.0542 2.83856 11.9805 2.81101 11.9172 2.79771C11.8771 2.75591 11.825 2.73406 11.7969 2.68656C11.7304 2.64761 11.728 2.60106 11.7705 2.70271C11.7809 2.73501 11.7785 2.80531 11.7833 2.81386C11.7344 2.75021 11.7448 2.73406 11.6903 2.73406C11.6527 2.70366 11.5982 2.67991 11.5701 2.63906C11.5188 2.63336 11.5156 2.61151 11.4635 2.59156C11.506 2.65141 11.5629 2.71031 11.5966 2.76636C11.6575 2.80626 11.6743 2.84236 11.7168 2.87656C11.7336 2.91171 11.7809 2.94021 11.7304 2.89271C11.6727 2.82621 11.6302 2.81006 11.5437 2.76636C11.494 2.71886 11.4763 2.69986 11.4234 2.65521C11.3513 2.62766 11.3793 2.61246 11.4234 2.70271C11.4739 2.75781 11.5124 2.81861 11.5565 2.86136C11.5911 2.9103 11.6316 2.95289 11.6767 2.98771C11.6887 3.00861 11.7248 3.01241 11.6767 3.01906C11.6366 2.97536 11.5773 2.94781 11.53 2.90791C11.4635 2.88606 11.4322 2.84521 11.3833 2.79771C11.3513 2.74166 11.3 2.69891 11.2631 2.65521C11.1862 2.61911 11.2783 2.68941 11.3032 2.73406C11.32 2.79201 11.3417 2.83856 11.3561 2.89271C11.3785 2.94496 11.2888 2.88036 11.2631 2.86136C11.2104 2.82087 11.1512 2.7937 11.0892 2.78156C11.036 2.76896 10.9826 2.7585 10.9289 2.75021C10.8687 2.73121 10.9617 2.79581 10.9962 2.86136C11.0635 2.93641 10.9297 2.87466 10.8896 2.86136C10.8234 2.84803 10.7563 2.84262 10.6892 2.84521C10.6034 2.85091 10.6651 2.86421 10.6892 2.90791C10.7156 2.93261 10.7341 2.98391 10.7293 3.00291C10.6732 2.99341 10.6251 2.97441 10.5553 2.97156C10.4992 2.99341 10.4327 2.98771 10.3686 2.98771C10.3662 3.02761 10.3806 2.99341 10.4086 3.03521C10.4551 3.05706 10.4856 3.08366 10.476 3.11406H10.0888C10.0463 3.12736 10.0976 3.12071 10.1289 3.17771C10.1113 3.22901 10.0888 3.20906 10.0351 3.20906C9.99904 3.19196 9.9261 3.18436 9.88843 3.16156C9.85076 3.16156 9.85396 3.15016 9.8219 3.14541C9.93412 3.24041 9.87801 3.21666 9.94213 3.28791C9.95255 3.29266 9.9782 3.30406 9.95496 3.30406L10.0087 2.38636Z",
    stroke: "#772600",
    strokeWidth: 0.244337
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85472 3.40687V3.41447C9.85472 3.39262 9.85472 3.40497 9.86835 3.44677C9.87316 3.48097 9.86193 3.47717 9.84831 3.50187C9.8459 3.53702 9.8419 3.56267 9.8419 3.60447C9.83709 3.63867 9.82105 3.67097 9.80823 3.69947C9.7954 3.72892 9.7401 3.74602 9.7417 3.78687C9.70964 3.79732 9.70883 3.77262 9.70803 3.73082C9.6888 3.70517 9.68238 3.67002 9.66796 3.63582C9.65994 3.60352 9.6407 3.57882 9.62788 3.54082C9.60864 3.50567 9.59181 3.49522 9.57497 3.45437C9.56776 3.43537 9.56936 3.41067 9.55493 3.39927C9.53329 3.36602 9.51886 3.36127 9.48119 3.35938C9.45233 3.36697 9.44111 3.38217 9.41466 3.39072C9.39382 3.39927 9.35374 3.39642 9.32809 3.40687C9.32168 3.41922 9.34092 3.42587 9.34813 3.45437C9.3305 3.47147 9.32408 3.50092 9.31446 3.52562C9.29843 3.54937 9.28801 3.56077 9.2808 3.59687C9.29202 3.61872 9.2824 3.64817 9.26797 3.66812C9.26316 3.70422 9.24793 3.72417 9.24072 3.75457C9.21988 3.77262 9.21186 3.78877 9.19423 3.81822C9.179 3.84387 9.16537 3.84197 9.1277 3.84197C9.09804 3.83247 9.09403 3.81347 9.06758 3.80207C9.06518 3.79257 9.06277 3.78972 9.05396 3.78687",
    stroke: "#782600",
    strokeWidth: 0.216412
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13188 3.72578C9.13188 3.72578 9.12001 3.87422 9.02501 3.97219C8.93001 4.07016 8.73407 4.18297 8.73407 4.18297C8.73407 4.18297 8.99829 4.05828 9.02501 4.085C9.0547 4.11469 8.85579 4.33141 8.85579 4.33141C8.85579 4.33141 9.11407 4.10281 9.14673 4.10281C9.17938 4.10281 9.2536 4.32547 9.28329 4.31953C9.31001 4.31359 9.22391 4.0375 9.23579 3.99297C9.24766 3.95141 9.23579 3.71687 9.23579 3.71687L9.13485 3.72578H9.13188ZM9.74048 3.70797C9.74048 3.70797 9.7286 3.86531 9.6336 3.96922C9.5386 4.07312 9.34266 4.19484 9.34266 4.19484C9.34266 4.19484 9.60688 4.06125 9.6336 4.09094C9.66329 4.12063 9.46438 4.35219 9.46438 4.35219C9.46438 4.35219 9.72267 4.10875 9.75532 4.10875C9.78798 4.10875 9.8622 4.34625 9.89188 4.34031C9.9186 4.33437 9.83251 4.0375 9.84438 3.99297C9.85626 3.94547 9.84438 3.69609 9.84438 3.69609L9.74048 3.70797ZM8.88844 2.28297C8.88844 2.30969 8.85876 2.33344 8.8261 2.33344C8.79344 2.33344 8.76079 2.30969 8.76079 2.28C8.76079 2.25031 8.79048 2.22656 8.8261 2.22656C8.86173 2.22656 8.88844 2.25031 8.88844 2.28V2.28297Z",
    fill: "#812E00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 14.25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEcuador);
export default __webpack_public_path__ + "static/media/ic-Ecuador.176ff8a1.svg";
export { ForwardRef as ReactComponent };